import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { analyticsConfigured, denyConsent, getConsent, grantConsent } from '../lib/analytics';

// Minimal consent bar (Consent Mode v2). Only shows when analytics IDs are configured and no choice is stored.
const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(analyticsConfigured() && !getConsent());
  }, []);

  if (!visible) return null;

  const decide = (fn) => () => {
    fn();
    setVisible(false);
  };

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      data-testid="cookie-consent"
      className="fixed bottom-16 left-4 right-4 sm:left-6 sm:right-auto sm:max-w-md z-50 bg-white/95 backdrop-blur border border-[var(--line-2)] rounded-2xl shadow-lg p-5 fade-up"
    >
      <div className="text-sm text-ink font-medium">Analytics cookies</div>
      <p className="text-xs text-ink-2 mt-1 leading-relaxed">
        We use Google Analytics and Microsoft Clarity to understand how visitors use this site and improve it. No advertising cookies.
        {' '}<Link to="/company" className="underline hover:text-ink">Learn more</Link>
      </p>
      <div className="mt-4 flex items-center gap-2">
        <button type="button" onClick={decide(grantConsent)} className="btn-primary text-xs py-2" data-testid="cookie-accept-btn">Accept</button>
        <button type="button" onClick={decide(denyConsent)} className="btn-secondary text-xs py-2" data-testid="cookie-decline-btn">Decline</button>
      </div>
    </div>
  );
};

export default CookieConsent;
